export const MODULE = "custom-work-order-print-modal";
